import { MedicalNotificationPayload } from "./notification.types";

const uuid = (value: string) => value;

export const TEST_NOTIFICATION_DEFAULTS: MedicalNotificationPayload = {
  entityType: "chat",
  entityId: uuid("b77182f6-2b93-4182-956f-0cf4b35170e4"),
  eventType: "added",
  requestingUserId: uuid("00000000-0000-4000-8000-000000000001"),
  targetUserId: uuid("00000000-0000-4000-8000-000000000002"),
  intent: "assistant_message",
  metadata: {
    source: "notification.test",
    note: "Default notification payload",
  },
};

export const ASSISTANT_MESSAGE_NOTIFICATION: MedicalNotificationPayload = {
  ...TEST_NOTIFICATION_DEFAULTS,
  metadata: {
    ...TEST_NOTIFICATION_DEFAULTS.metadata,
    messageContent: "Assistant summary",
    userMessageId: uuid("11111111-1111-1111-1111-111111111111"),
  },
};

export const DEPENDENT_UPLOAD_NOTIFICATION: MedicalNotificationPayload = {
  entityType: "medical_record",
  entityId: uuid("aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa"),
  eventType: "added",
  requestingUserId: uuid("00000000-0000-4000-8000-000000000003"),
  targetUserId: uuid("00000000-0000-4000-8000-000000000004"),
  intent: "dependent_upload",
  metadata: {
    dependentUserId: uuid("bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb"),
    dependentName: "Ella",
    uploaderName: "Jordan",
    fileCount: 2,
    fileNames: ["Lab Results.pdf", "Discharge Summary.pdf"],
  },
};

export const MEDICAL_RECORD_AI_SUMMARY_NOTIFICATION: MedicalNotificationPayload = {
  entityType: "medical_record",
  entityId: uuid("cccccccc-cccc-cccc-cccc-cccccccccccc"),
  eventType: "updated",
  requestingUserId: uuid("00000000-0000-4000-8000-000000000005"),
  targetUserId: uuid("00000000-0000-4000-8000-000000000006"),
  intent: "ai_summary_completed",
  metadata: {
    messageId: uuid("dddddddd-dddd-dddd-dddd-dddddddddddd"),
    assistantMessageId: uuid("eeeeeeee-eeee-eeee-eeee-eeeeeeeeeeee"),
    summary: "AI summary completed.",
  },
};

export const GROUP_CHAT_INVITE_NOTIFICATION: MedicalNotificationPayload = {
  entityType: "chat",
  entityId: uuid("ffffffff-ffff-ffff-ffff-ffffffffffff"),
  eventType: "added",
  requestingUserId: uuid("00000000-0000-4000-8000-000000000007"),
  targetUserId: uuid("00000000-0000-4000-8000-000000000008"),
  intent: "invite",
  metadata: {
    groupChatId: uuid("10101010-1010-1010-1010-101010101010"),
    groupChatName: "Care Team",
    groupChatLink:
      "https://app.harper.new/group-chat/10101010-1010-1010-1010-101010101010",
    inviterName: "Dr. Rivera",
  },
};

export const USER_RELATIONSHIP_INVITE_NOTIFICATION: MedicalNotificationPayload = {
  entityType: "user_relationship",
  entityId: uuid("20202020-2020-2020-2020-202020202020"),
  eventType: "added",
  requestingUserId: uuid("00000000-0000-4000-8000-000000000009"),
  targetUserId: uuid("00000000-0000-4000-8000-000000000010"),
  intent: "invite",
  metadata: {
    inviteLink: "https://app.harper.new/invite/abcd",
    inviterName: "Alex",
    relationship: "Caregiver",
  },
};

export const MEDICAL_TRANSCRIPTION_SHARE_NOTIFICATION: MedicalNotificationPayload = {
  entityType: "content",
  entityId: uuid("30303030-3030-3030-3030-303030303030"),
  eventType: "added",
  requestingUserId: uuid("00000000-0000-4000-8000-000000000011"),
  targetUserId: uuid("00000000-0000-4000-8000-000000000012"),
  intent: "medical_transcription_share",
  metadata: {
    senderName: "Dr. Patel",
    transcriptLink:
      "https://app.harper.new/transcripts/30303030-3030-3030-3030-303030303030",
    patientName: "Taylor",
    visitDate: "Nov 10, 2025",
    transcriptSummary: "Follow-up in two weeks.",
  },
};

export const AMBIENT_CONVERSATION_SHARE_NOTIFICATION: MedicalNotificationPayload = {
  entityType: "ambient_conversation",
  entityId: uuid("40404040-4040-4040-4040-404040404040"),
  eventType: "shared",
  requestingUserId: uuid("00000000-0000-4000-8000-000000000013"),
  targetUserId: uuid("00000000-0000-4000-8000-000000000014"),
  metadata: {
    conversationId: uuid("50505050-5050-5050-5050-505050505050"),
    shareLink:
      "https://app.harper.new/ambient/50505050-5050-5050-5050-505050505050",
  },
};

export const NOTIFICATION_EXAMPLES: Record<string, MedicalNotificationPayload> = {
  default: TEST_NOTIFICATION_DEFAULTS,
  assistantMessage: ASSISTANT_MESSAGE_NOTIFICATION,
  dependentUpload: DEPENDENT_UPLOAD_NOTIFICATION,
  medicalRecordSummary: MEDICAL_RECORD_AI_SUMMARY_NOTIFICATION,
  groupChatInvite: GROUP_CHAT_INVITE_NOTIFICATION,
  userRelationshipInvite: USER_RELATIONSHIP_INVITE_NOTIFICATION,
  medicalTranscriptionShare: MEDICAL_TRANSCRIPTION_SHARE_NOTIFICATION,
  ambientConversationShare: AMBIENT_CONVERSATION_SHARE_NOTIFICATION,
};
